import { Flow_0_0_2 } from '@flexus/core';

export const BET_28: Flow_0_0_2 = {
	id: '28',
	name: 'job_complete',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'All Done'
		},
		viewRoles: {
			0: 'All Done'
		}
	},
	startNode: '',
	nodes: {}
};
